import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import config from '@/config';
import { DownloadButton } from '@/components/DownloadButton';
import Dropdown from '@/components/Dropdown';
import s from './index.module.scss'

export const FinancingAgreements = ({ fundraisingId, data }) => {
  const { t } = useTranslation('loans');
  if (!data) return null;

  return (
    <div className={classnames(s.wrapper, data?.insurance_strategy)}>
      <Dropdown
        label={
          <div className={s.header}>
            <h2 className="f-22 f-500">{t('fin_agreements.header')}</h2>
          </div>
        }
      >
        {fundraisingId === 92 ? (
          <div className={classnames(s.empty_message, 'f-16')}>
            {t('fin_agreements.processing_message')}
          </div>
        ) : data ? (
          <div className={s.table}>
            <div className={s.thead}>
              <div className={s.thead_col}>{t('fin_agreements.loan_type')}</div>
              <div className={s.thead_col}>{t('fin_agreements.loan_number')}</div>
              <div className={s.thead_col}>{t('fin_agreements.download_agreements')}</div>
            </div>
            <div className={s.tbody}>
              {data.agreements.map(agreement => (
                <div className={s.tbody_row} key={agreement.id}>
                  <div className={s.tbody_col}>{agreement.risk_group_title}</div>
                  <div className={s.tbody_col}>
                    {t('fin_agreements.loan_number_prefix', { id: agreement.id })}
                  </div>
                  <div className={s.tbody_col}>
                    <DownloadButton
                      filename={`loan-assignments-${agreement.id}`}
                      link={`${config.apiURL}/founders/loans/${agreement.id}/assignments/`}
                    >
                      {t('fin_agreements.download')}
                    </DownloadButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className={classnames(s.empty_message, 'f-16')}>
            {t('fin_agreements.no_agreements')}
          </div>
        )}
      </Dropdown>
    </div>
  );
};
